import { List, Map, OrderedSet } from "immutable";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getImages } from "data/assets";
import {
  getCampaignCategories,
  getEntityMicrositeCampaignId,
  getSelectCategoryCopy,
} from "data/entity";

import { setCampaign as selectParentCampaign } from "data/parent-campaign";
import { getParentSectionId } from "data/voting-form/parent-section";

import { fetchCampaigns } from "data/campaigns";

import { getPaginationInfo, setInitialPagination } from "data/pagination";

import { nextPage } from "data/voting-form/routes";
import {
  getCampaignThatLaunchedForm,
  getFilteredCampaigns,
  getLoading,
  getQuery,
  getSelectedCategory,
  selectCategory,
  setQuery,
  toggleLoading,
} from "data/voting-form/voting";

import InputDebounced from "lib/components/InputDebounced";
import SelectOptions from "lib/components/SelectOptions";
import AmploButton from "shared/ui/amplo-button";
import CampaignSelectItem from "../components/CampaignSelectItem";

class SelectParentCampaigns extends React.Component {
  handleInput = (e) => {
    e.preventDefault();
    const { setQuery } = this.props;
    const val = e.target.value;

    setQuery(val);

    this.handleSubmit();
  };

  _fetchCampaigns(options) {
    const { fetchCampaigns, toggleLoading, setPaginationTotal, setInitialPagination } =
      this.props;

    toggleLoading();

    fetchCampaigns(options).then(({ total }) => {
      setInitialPagination({ total });
      toggleLoading();
    });
  }

  handleSubmit = (e) => {
    const {
      query,
      selectedCategory,
      campaignId,
      entityId,
      sectionId,
      entityMicrositeCampaignId,
    } = this.props;

    if (e) {
      e.preventDefault();
    }

    let options = {
      category: selectedCategory,
      query,
      resetCampaigns: true,
    };

    if (entityMicrositeCampaignId) {
      options = Object.assign(options, { campaignId: entityMicrositeCampaignId });
    } else if (sectionId) {
      options = Object.assign(options, { sectionId });
    } else {
      options = Object.assign(options, { campaignId });
    }

    this._fetchCampaigns(options);
  };

  handlePagination = (e) => {
    const { selectedCategory, query, sectionId, campaignId, entityMicrositeCampaignId } =
      this.props;

    const { toggleLoading, fetchCampaigns } = this.props;

    let options = {
      query,
      category: selectedCategory,
      nextPage: true,
    };

    if (entityMicrositeCampaignId) {
      options = Object.assign(options, { campaignId: entityMicrositeCampaignId });
    } else if (sectionId) {
      options = Object.assign(options, { sectionId });
    } else if (leaderboardId) {
      options = Object.assign(options, { leaderboardId });
    } else {
      options = Object.assign(options, { campaignId });
    }

    toggleLoading();

    fetchCampaigns(options).then(() => {
      toggleLoading();
    });
  };

  handleParentSelection = (campaign) => {
    const { nextPage, selectParentCampaign } = this.props;

    selectParentCampaign(campaign);
    nextPage();
  };

  handleParentCategorySelection = (category) => {
    const { query, sectionId, campaignId, entityMicrositeCampaignId } = this.props;

    const { selectCategory } = this.props;

    let options = {
      query,
      category,
      resetCampaigns: true,
    };

    if (entityMicrositeCampaignId) {
      options = Object.assign(options, { campaignId: entityMicrositeCampaignId });
    } else if (sectionId) {
      options = Object.assign(options, { sectionId });
    } else if (leaderboardId) {
      options = Object.assign(options, { leaderboardId });
    } else {
      options = Object.assign(options, { campaignId });
    }

    selectCategory(category);
    this._fetchCampaigns(options);
  };

  componentDidMount() {
    const { sectionId, entityMicrositeCampaignId } = this.props;

    let options = {};

    if (entityMicrositeCampaignId) {
      options = Object.assign(options, { campaignId: entityMicrositeCampaignId });
    } else {
      options = Object.assign(options, { sectionId });
    }

    this._fetchCampaigns(options);
  }

  renderLoader() {
    const { isLoading } = this.props;

    if (isLoading) {
      return (
        <div className="m-md-t text-center">
          <i className="fa fa-3x fa-refresh fa-spin" />
        </div>
      );
    }
  }

  renderCampaigns() {
    const { campaigns, isLoading } = this.props;

    let content;

    if (isLoading == true || campaigns.count() > 0) {
      content = campaigns.map((campaign) => {
        return (
          <CampaignSelectItem
            key={campaign.get("id")}
            campaign={campaign}
            onSelected={this.handleParentSelection}
          />
        );
      });
    } else {
      content = (
        <div className="m-md-t text-center">
          No campaigns found!&nbsp;
          <a data-testid="t-SelectP-a" className="pointer" onClick={this.handleSubmit}>
            Please search again.
          </a>
        </div>
      );
    }

    return (
      <div>
        {content}
        {this.renderLoader()}
      </div>
    );
  }

  formatCategoryText(category) {
    const { selectCategoryCopy } = this.props;

    if (!category || category === "") {
      return selectCategoryCopy;
    } else {
      return category;
    }
  }

  renderDropdown() {
    const { selectCategoryCopy, selectedCategory, images, campaignCategories } =
      this.props;

    const categoryText = this.formatCategoryText(selectedCategory);

    let categoryImage;
    let formattedCategory = selectedCategory;

    if (!selectedCategory || selectedCategory === "") {
      formattedCategory = selectCategoryCopy;
      categoryImage = images.get("all_categories");
    } else {
      categoryImage = images.get(selectedCategory.toLowerCase().replace(/ /g, "_"));
    }

    return (
      <div className="search-category">
        <span className="search-category-selected">
          <img src={categoryImage} className="search-category-selected-img" />
          <span className="search-category-selected-name">
            {categoryText}
            <i className="fa fa-check primary-color-text p-xs-l" />
          </span>
        </span>
        <span className="search-category-drop-down">
          <SelectOptions
            displayText={selectCategoryCopy}
            selected={selectedCategory}
            items={campaignCategories}
            selectItemAction={this.handleParentCategorySelection}
          />
        </span>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      pagination: { hasPagesRemaining },
    } = this.props;

    const { onCloseModal } = this.props;

    return (
      <section className="voting-modal primary-color-background">
        <div className="voting-modal-background p-lg-b">
          <button
            data-testid="t-SelectP-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button secondary-color-text"
            onClick={() => onCloseModal()}>
            <i className="fa fa-times fa-2x" />
          </button>
          <div className="voting-modal-top">
            <div className="voting-modal-header-area">
              <h2 className="voting-modal-header">
                <span className="step-active secondary-color-text">Give</span> &gt; Vote
                &gt; Watch
              </h2>
              <span className="white-font-color">Designate your gift.</span>
            </div>
          </div>
          <div className="voting-modal-body">
            <div className="voting-modal-body-inside">
              <form
                data-testid="t-SelectP-form-3"
                className="cause-search"
                onSubmit={this.handleSubmit}>
                <div className="voting-search__input-group">
                  <InputDebounced
                    className="voting-search__input primary-color-border"
                    onChange={this.handleInput}
                    type="search"
                    aria-label="Search"
                    placeholder="Search..."
                  />
                  <button
                    data-testid="t-SelectP-submit"
                    aria-label="Submit"
                    className="voting-search-button primary-color-border"
                    type="submit">
                    <i className="fa fa-search" />
                  </button>
                </div>
              </form>

              {this.renderDropdown()}

              <div className="search-results">
                {this.renderCampaigns()}
                <div className="text-center">
                  <AmploButton
                    hide={isLoading || !hasPagesRemaining}
                    onClick={this.handlePagination}>
                    load more campaigns
                  </AmploButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

SelectParentCampaigns.propTypes = {
  campaigns: PropTypes.instanceOf(OrderedSet).isRequired,

  campaignCategories: PropTypes.instanceOf(List).isRequired,
  campaignId: PropTypes.string.isRequired,
  sectionId: PropTypes.string,

  isLoading: PropTypes.bool.isRequired,
  query: PropTypes.string,
  parentCategory: PropTypes.string,
  selectedCategory: PropTypes.string,
  selectCategoryCopy: PropTypes.string.isRequired,
  pagination: PropTypes.object.isRequired,

  nextPage: PropTypes.func.isRequired,
  fetchCampaigns: PropTypes.func.isRequired,
  selectParentCampaign: PropTypes.func.isRequired,
  selectCategory: PropTypes.func.isRequired,
  setQuery: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    selectCategoryCopy: getSelectCategoryCopy(state),
    selectedCategory: getSelectedCategory(state),
    campaignCategories: getCampaignCategories(state),
    campaigns: getFilteredCampaigns(state),
    pagination: getPaginationInfo()(state),
    entityMicrositeCampaignId: getEntityMicrositeCampaignId(state),
    images: getImages(state),
    campaignId: getCampaignThatLaunchedForm(state),
    sectionId: getParentSectionId(state),
    isLoading: getLoading(state),
    query: getQuery(state),
  };
};

const mapActionCreators = {
  fetchCampaigns,
  nextPage,
  selectCategory,
  selectParentCampaign,
  setQuery,
  toggleLoading,

  setInitialPagination({ total }) {
    return setInitialPagination({
      total,
    });
  },
};

export default connect(mapStateToProps, mapActionCreators)(SelectParentCampaigns);
